import React from "react";
import { graphql } from 'gatsby';

import SEO from "../../components/seo"
import PageWrapper from "../../components/_molecules/page-wrapper";
import HtmlContentWrapper from "../../components/_molecules/html-content-wrapper";
import HtmlContent from "../../components/_molecules/html-content";
import ContactSection from "../../sections/contact";
import PageHero from "../../components/_organisms/page-hero";
import { Content } from "./page-styles";

const resolveExtension = extension => {
    const extensionComponents = {
        "contact": ContactSection
    };

    if (extensionComponents[extension]) {
        const Extension = extensionComponents[extension];
        return (<Extension key={`page-extension-${extension}`}/>)
    }

    return null;
};

export default ({ data }) => {
    const { pagesJson: page } = data;
    return (
        <>
            <SEO
                title={page.title}
                description={page.metaDescription}
                image={(page.openGraphImage && page.openGraphImage[0].src.childImageSharp.fixed.src) || null}
                slug={`/${page.slug}`}
            />
            <PageHero
                images={page.heroImages}
                title={page.title}
                description={page.metaDescription}
            />
            <PageWrapper>
                <Content>
                    <HtmlContentWrapper>
                        <HtmlContent html={page.bodyContent.html} />
                        {
                            page.extensions && page.extensions.map(resolveExtension)
                        }
                    </HtmlContentWrapper>
                </Content>
            </PageWrapper>
        </>        
    );
};

export const pageQuery = graphql`
    query PageByPath($slug: String!) {
        pagesJson(slug: { eq: $slug }) {
            id
            title
            metaDescription
            heroImages {
                name
                src {
                    childImageSharp {
                        fixed(width: 700, height: 350, cropFocus: NORTH) {
                            ...GatsbyImageSharpFixed
                        }  
                        fluid(quality: 90, maxWidth: 1920, maxHeight: 350) {
                            ...GatsbyImageSharpFluid_withWebp_tracedSVG
                        }
                        fluidThumb: fluid(quality: 90, maxWidth: 1920, maxHeight: 1080, cropFocus: NORTH) {
                            ...GatsbyImageSharpFluid_withWebp
                        }               
                    }   
                }
            }
            openGraphImage: heroImages {
                name
                src {
                    childImageSharp {
                        fixed(width: 1200, height: 630) {
                            src
                        }
                    }
                }
            }
            bodyContent: _bodyContent {
                id
                html
            }
            slug
        }
    }
`;